import { EmptyPage } from '../../components/EmptyPage';
import { useFiltersButton } from '../../hooks';
import * as React from 'react';

export const EmptyPageContainer = () => {
  const handleClick = useFiltersButton();

  return <EmptyPage onFiltersButtonClick={handleClick} />;
};
